import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import ServicesComponent from "@/pages/about-us/AboutUsComponents/ServicesComponents/ServicesComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { servicesData } from "./ServicesData";
import { api__doSearch } from "@/apis/search/search";
import { useTranslation } from "@i18n";
var Services = function Services() {
  var _useTranslation = useTranslation(["web_about_us", "web_common"]),
    t = _useTranslation.t;
  var _useState = useState([]),
    posts = _useState[0],
    setPosts = _useState[1];
  useEffect(function () {
    var data = {
      filters: {},
      link: "",
      page: 1,
      sort: "",
      size: 4,
      new_path: false
    };
    api__doSearch(null, 1, data).then(function (res) {
      setPosts(res.products);
    });
  }, []);
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    mainClass: "services",
    linksForSearch: true,
    hasMobFooter: true,
    authenticationMsg: true
  }, /*#__PURE__*/React.createElement(ServicesComponent, {
    servicesData: servicesData(t),
    posts: posts
  }));
};
export default Services;